var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpactedLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.375C0 1.41797 0.765625 0.625 1.75 0.625L5.35938 0.625C5.87891 0.625 6.37109 0.84375 6.75391 1.22656L7.90234 2.375L12.25 2.375C13.207 2.375 14 3.16797 14 4.125V11.125C14 12.1094 13.207 12.875 12.25 12.875H1.75C0.765625 12.875 0 12.1094 0 11.125L0 2.375ZM1.75 1.9375C1.50391 1.9375 1.3125 2.15625 1.3125 2.375L1.3125 11.125C1.3125 11.3711 1.50391 11.5625 1.75 11.5625H12.25C12.4688 11.5625 12.6875 11.3711 12.6875 11.125V4.125C12.6875 3.90625 12.4688 3.6875 12.25 3.6875L7.82031 3.6875C7.54688 3.6875 7.24609 3.57812 7.05469 3.38672L5.82422 2.12891C5.6875 2.01953 5.52344 1.9375 5.35938 1.9375L1.75 1.9375Z",
    fill: "#666C74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactedLocations);
export default __webpack_public_path__ + "static/media/impacted-locations.94d5d46816b355a4e9c2edd3e3d0c580.svg";
export { ForwardRef as ReactComponent };